var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('section-component',{attrs:{"form":_vm.form}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }